import * as React from 'react';
import styled from '@emotion/styled';
import { lighten } from 'polished';

import { colors } from '../styles/colors';

const ImageInfoWrapper = styled.div`
  padding: 2.5rem 1rem 1rem;
  border-top: ${lighten('0.02', colors.whitegrey)} 1px solid;
  text-align: center;
  background: linear-gradient(to bottom, ${lighten('0.04', colors.whitegrey)}, white);

  ul {
    column-count: 2;
    list-style-type: none;
  }
  li {
    padding-left: 0;
    line-height: 1.3;
  }
  li span {
    text-decoration: ${colors.whitegrey} underline;
  }

  @media (max-width: 500px) {
    ul {
      font-size: 1.6rem;
    }
  }
`;

const ImageInfo = ({
  camera,
  focal,
  aperture,
  iso,
  shutter,
}: {
  camera: string;
  focal?: string;
  aperture: string;
  iso: string;
  shutter: string;
  source?: string;
}) => {
  return (
    <ImageInfoWrapper>
      <ul>
        <li>
          <span>Camera</span>: {camera}
        </li>
        {focal && (
          <li>
            <span>Focal length</span>: {focal}
          </li>
        )}
        <li>
          <span>Shutter speed</span>: {shutter}s
        </li>
        <li>
          <span>Aperture</span>: f/{aperture}
        </li>
        <li>
          <span>ISO</span>: {iso}
        </li>
      </ul>
    </ImageInfoWrapper>
  );
};

export default ImageInfo;
